<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import MediaInteraction from '../../interactions/media/MediaInteraction.svelte';

    let props = $props();

    function prepareClasses(classes = '') {
        let classList = classes.split(' ');

        // filter out linear restriction
        classList = classList.filter(item => item !== 'tao-media-mode-linear');

        // add review mode indicator class
        classList.push('qti-reviewInteraction');

        // make sure allow pause class is added
        if (!classList.includes('pause')) {
            classList.push('pause');
        }

        // make sure controls show
        classList = classList.filter(item => item !== 'hide-player');

        return classList.join(' ');
    }

    let newProps = $derived(
        Object.assign({}, props, {
            classes: prepareClasses(props.classes),
            autostart: false,
            loop: false,
            minPlays: 0,
            maxPlays: 0
        })
    );
</script>

<MediaInteraction {...newProps} />
